import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar_full_press",
  "use": "calendar_full_press-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"calendar_full_press\"><path d=\"M14.07 3h-.32V2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1h-2.5V2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1h-2.5V2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1h-.32C2.86 3 2 3.86 2 4.93V6h11c0 .83-.67 1.5-1.5 1.5H2v6.57C2 15.13 2.86 16 3.93 16h10.15c1.06 0 1.93-.86 1.93-1.93V4.93A1.94 1.94 0 0 0 14.07 3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol